export const SURFACE_KINDS = Object.freeze([
  "pageColumn",
  "contentPanel",
  "brandBand",
  "navStrip",
  "subtlePanel",
  "heroGradient",
]);

export const LEGACY_CONTAINER_ALIASES = Object.freeze({
  primary: "pageColumn",
  white: "contentPanel",
  primaryGreen: "brandBand",
  tertiaryGreen: "navStrip",
  tertiaryWhite: "subtlePanel",
  gradient: "heroGradient",
});

export const SURFACE_USE_CASES = Object.freeze({
  pageColumn: "Full-width page section — no gutters (replaces Container variant=primary).",
  contentPanel: "White/card panel on the page canvas (replaces Container variant=white).",
  brandBand: "Full-bleed green marketing band (replaces primaryGreen).",
  navStrip: "Breadcrumb / top-bar strip (replaces tertiaryGreen).",
  subtlePanel: "Off-white inset panel (replaces tertiaryWhite).",
  heroGradient: "Landing hero gradient band (replaces gradient).",
});

export function pageColumnSx(theme) {
  const legacyDarkColumn =
    theme.palette.mode === "dark" && !theme.palette.neutral?.pageBg;

  return {
    width: "100%",
    maxWidth: "100%",
    borderRadius: 0,
    color: "text.primary",
    p: 0,
    bgcolor: legacyDarkColumn ? "rgba(26, 29, 33, 1)" : "transparent",
  };
}

export function contentPanelSx(theme) {
  const panelBg =
    theme.palette.mode === "dark" && theme.palette.neutral?.surface
      ? theme.palette.neutral.surface
      : theme.palette.background.white;

  return {
    width: "100%",
    maxWidth: "100%",
    borderRadius: 0,
    color: "text.primary",
    p: 0,
    bgcolor: panelBg,
  };
}

export function brandBandSx(theme) {
  return {
    width: "100%",
    maxWidth: "none",
    borderRadius: 0,
    color: theme.palette.text.white,
    p: 0,
    bgcolor: theme.palette.background.primaryGreen,
  };
}

export function navStripSx(theme) {
  return {
    width: "100%",
    maxWidth: "none",
    borderRadius: 0,
    color: "text.primary",
    p: 0,
    bgcolor:
      theme.palette.mode === "dark"
        ? theme.palette.neutral.surface
        : theme.palette.background.tertiaryGreen,
  };
}

export function subtlePanelSx(theme) {
  const panelBg =
    theme.palette.mode === "dark"
      ? theme.palette.neutral.surface
      : theme.palette.background.tertiaryWhite;

  return {
    width: "100%",
    maxWidth: "100%",
    borderRadius: 0,
    color: "text.primary",
    p: 0,
    bgcolor: panelBg,
  };
}

export function heroGradientSx() {
  return {
    width: "100%",
    maxWidth: "100%",
    borderRadius: 0,
    color: "text.primary",
    p: 0,
    background:
      "linear-gradient(90deg, rgba(0, 102, 51, 0.3) 0%, rgba(0, 77, 38, 0.2) 100%), #004D26",
  };
}

export function centerStageLayoutSx(theme) {
  return {
    ...pageColumnSx(theme),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    py: "2rem",
  };
}

export const SURFACE_SX = Object.freeze({
  pageColumn: pageColumnSx,
  contentPanel: contentPanelSx,
  brandBand: brandBandSx,
  navStrip: navStripSx,
  subtlePanel: subtlePanelSx,
  heroGradient: heroGradientSx,
});
